import { faArrowCircleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";
import getCorePopUpStore from "../../../../../stores/core/core-popup-store";

const UserSaveIcon = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, getFontSize } = theme;
  const ifPopUpCommentsOpened =
    getCorePopUpStore().confirmationPopUpType.get() !== "EMPTY_STRING";
  const ifCommentAccepted = getUserAdvancedStore().isCommentAccepted.get();
  const isButtonEnabled = !ifPopUpCommentsOpened && ifCommentAccepted;

  return (
    <FontAwesomeIcon
      className="clickable"
      onClick={() => {
        if (!isButtonEnabled) {
          return;
        }
        getCorePopUpStore().openConfirmationPopUps("ADD_COMMENT_POPUP");
      }}
      icon={faArrowCircleRight}
      color={isButtonEnabled ? colors.all.green : colors.all.gray}
      style={{
        pointerEvents: isButtonEnabled ? "auto" : "none",
        fontSize: getFontSize(80)
      }}
      size="2x"
    />
  );
});
export default UserSaveIcon;
